import React from 'react';

import { Box, Grid, Typography } from '@mui/material';

import { COLOR_DISABLED } from '~/components/App/theme';
import { DisplayJiraStatus } from '~/components/JiraStatus';
import { OpenIssueCount } from '~/components/OpenIssueCount';
import { IRequest } from '~/domain/IRequest';

import { RequestLink } from './RequestLink';
import { TruncateBox } from './TruncateBox';

interface IRequestItem {
  request: IRequest;
}

export const RequestItem: React.FC<IRequestItem> = (props) => {
  const { request } = props;
  const { requestId, title, buildVersion, dueDate, productionRound, status } = request;
  const isRequestDisabled = !productionRound?.value;

  return (
    <Box
      sx={{
        borderRadius: '6px',
        mb: '4px',
        p: '21px 40px',
        lineBreak: 'anywhere',
        color: ({ palette }) => palette.primary.light,
        bgcolor: ({ palette }) => palette.background.paper,
        '&:not(:hover, :focus) a': {
          color: ({ palette }) => palette.text.primary,
        },
        '&:hover, &:focus': {
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          mb: '6px',
        },
      }}
    >
      <Grid container sx={{ alignItems: 'center' }}>
        <Grid item xs={4}>
          <TruncateBox>
            <RequestLink requestId={requestId} disabled={isRequestDisabled}>
              {title}
            </RequestLink>
            <Typography variant="body1" sx={{ mt: '2px', color: isRequestDisabled ? COLOR_DISABLED : undefined }}>
              {'Build version: '}
              <Typography component="span" variant='subtitle1' sx={{ color: isRequestDisabled || !buildVersion ? COLOR_DISABLED : undefined }}>
                {buildVersion || 'Not Available'}
              </Typography>
            </Typography>
          </TruncateBox>
        </Grid>
        <Grid item xs={2}>
          <TruncateBox>
            <Typography variant="body1">
              Round Due Date
            </Typography>
            <Typography variant="subtitle1" sx={{ mt: '8px', color: isRequestDisabled || !dueDate ? COLOR_DISABLED : undefined }}>
              {dueDate || 'Not Available'}
            </Typography>
          </TruncateBox>
        </Grid>
        <Grid item xs={2}>
          <TruncateBox>
            <Typography variant="body1">
              Review Round
            </Typography>
            <Typography variant="subtitle1" sx={{ mt: '8px', color: isRequestDisabled || isRequestDisabled ? COLOR_DISABLED : undefined }}>
              {productionRound?.value || 'Not Available'}
            </Typography>
          </TruncateBox>
        </Grid>
        <Grid item xs={2}>
          <TruncateBox>
            <Typography variant="body1">
              Open Issues
            </Typography>
            <OpenIssueCount requestId={requestId} sx={{ mt: '8px', color: isRequestDisabled ? COLOR_DISABLED : undefined }} />
          </TruncateBox>
        </Grid>
        <Grid item xs={2}>
          <TruncateBox>
            <DisplayJiraStatus status={status} disabled={isRequestDisabled} />
            <Typography variant="body2" sx={{ mt: '10px', color: isRequestDisabled ? COLOR_DISABLED : undefined }}>
              {`Ticket#: ${requestId}`}
            </Typography>
          </TruncateBox>
        </Grid>
      </Grid>
    </Box>
  );
};
